import { CustomDateFormatPipe } from "@school/a2z-lib";
import { environment } from "../../../environments/environment";


//env
export const apiUrl = environment.apiBase + '/' + environment.apiVersion;
export const xapiKey = environment.xApiToken;
export const apiVersion = environment.apiVersion;


//values
export const UserType = 'client';
export const LandingPageTitle = 'Teleconsult';


//contents


export const HomeTitle = '';
export const HomeSubmsg = '';

//URLS
export const ForgotPasswordLink = '/auth/forgotpassword';
export const FactorVerificationLink = '/auth/factorverification';
export const LoginLink = 'auth/login';
// export const DashboardLink = environment.apiVersion + '/teleconsult';
export const DashboardLink = '/forms';
export const Signuplink = '/auth/signup';

//Pagination
export const PageSize = '10';
export const PageSizeOptions = ['10', '20'];

//Date Formats

export const MyDate_Formats = {
  parse: {
    dateInput: 'MM/YYYY',
  },
  display: {
    //   dateInput: CustomDateFormatPipe,
    dateInput: "DD-MMM-YYYY",
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};


//slots
export const TimeSlots = true;
export const QueueSlots = true;

//encrypt Key
export const encryptKey = "ain44j3hf998unc2nmcm238n34mc12398384mn";
export const plusEncryptKey = "999999999s";
export const slashEncryptKey = "999999999h";
export const equalEncryptKey = "999999999e";

//rights
export const StaffHealthAccess = { Edit: false, Create: false };
export const StudenHealthtAccess = { Edit: false, Create: false };
export const SecondaryProviderAccess = { Edit: false, Create: false };
export const ProviderAccess = { Edit: true, Create: true };


//Teleconsult
export const TeleconsultProviderLink = environment.teleconsultLinks.provider;
export const TeleconsultStatus = {
  approved: 'APPROVED',
  rejected: 'REJECTED',
}

export const TeleconsultFilterStatus = ['new', "waiting", "ended", "started", "cancelled"];
